export const headingRegExp = /h[1-7]/;
export const headingPseudoNameRegExp = /{{(.*?)}}/;

export const slugify = (str) =>
	str
		?.replace?.(/[&^%$#@!)(*.?,)]/g, '')
		?.replace(/\s+/g, ' ')
		?.trim()
		?.replace?.(/\s/g, '-')
		?.toLowerCase?.() || '';

export function generateTreeForPost(
	post,
	{ isCurrent = false, levels = null, getBaseHref = () => '/' } = {},
) {
	const baseHref = getBaseHref();
	const tree = {
		title: post.title,
		key: baseHref,
		href: baseHref,
		level: 0,
	};
	if (!post.body) {
		return tree;
	}
	const blocks = post.body.filter((block) => {
		const isHeading = headingRegExp.test(block.style);
		if (!isHeading) {
			return false;
		}
		if (levels?.length) {
			const currentLevel = +block.style.slice(1);
			return levels.includes(currentLevel);
		}
		return true;
	});
	let currentParent = tree;
	let lastAddedBlock = null;
	const createdBlocks = [];
	blocks.forEach((block) => {
		const currentHeadingLevel = +block.style.slice(1);
		if (lastAddedBlock && lastAddedBlock.level < currentHeadingLevel) {
			currentParent = lastAddedBlock;
		} else if (lastAddedBlock && lastAddedBlock.level > currentHeadingLevel) {
			// go up in the tree structure, find the first parent with appropriate level
			const lastSameLevelElement = createdBlocks.find((b) => b.el.level === currentHeadingLevel);
			currentParent = lastSameLevelElement?.parent || tree;
		}
		const titleText = block.children[0].text || '';
		const title = titleText.replace(headingPseudoNameRegExp, '') || '';
		const menuTitle = titleText.match(headingPseudoNameRegExp)?.[1] || title;
		const baseSlug = slugify(title);
		let slug = baseSlug;
		let relativeHref;
		if (currentParent) {
			if (currentParent.level !== 0) {
				slug = `${currentParent.slug}-${baseSlug}`;
			}
			relativeHref = `#${slug}`;
		}
		const href = isCurrent ? relativeHref : `${baseHref}${relativeHref}`;
		// add nested items
		const newBlock = {
			title,
			href,
			key: slug,
			_key: block._key,
			slug,
			menuTitle,
			level: currentHeadingLevel,
		};
		createdBlocks.unshift({ el: newBlock, parent: currentParent });
		if (!currentParent.children) {
			currentParent.children = [];
		}
		currentParent.children.push(newBlock);
		lastAddedBlock = newBlock;
	});

	return tree;
}
